import { useAuth } from "@/app/AuthContext";
import { LoginPage } from "@/features/auth/LoginPage";
import { AccessDenied } from "@/features/auth/AccessDenied";
import { AppRoutes } from "@/app/routes";

/**
 * The gate. Everything in this app is behind a session, so there is exactly one way in, and the
 * router is only reached once past it - an unauthenticated visitor has no routes at all.
 *
 * Order matters: `accessDenied` is checked before `isAuthenticated`, because an account with no
 * roles has a perfectly good session and no user object - falling through to the login page would
 * sign it straight back in.
 */
export function App() {
  const { isLoading, isAuthenticated, accessDenied } = useAuth();

  if (isLoading) {
    return (
      <main className="flex min-h-dvh items-center justify-center text-sm text-text-muted">
        Checking your session…
      </main>
    );
  }

  if (accessDenied) return <AccessDenied />;
  if (!isAuthenticated) return <LoginPage />;
  return <AppRoutes />;
}
